import { Injectable } from '@angular/core';
import type { MapboxMap } from '@polaris-customerweb/sharedcomponents.core';
import { ConsoleLogService } from '@polaris-customerweb/sharedcomponents.shared';
import { InProgressRideService } from '../state/in-progress-ride/in-progress-ride.service';
import { InProgressRideVm } from '../state/in-progress-ride/in-progress-ride.vm';
import { MapContentMapService } from './map-content-map.service';
import { MapService } from './map.service';

@Injectable({ providedIn: 'root' })
export class InProgressRideMapService extends MapContentMapService {
    minZoom = 8;

    constructor(
        consoleLogService: ConsoleLogService,
        mapService: MapService,
        private inProgressRideService: InProgressRideService
    ) {
        super(consoleLogService, mapService);
        super.setSourceId('connectedtrackedridesactive');
    }

    setSourceDataFromModel(
        mapboxMap: MapboxMap,
        inProgressRides: readonly InProgressRideVm[]
    ) {
        const geoJson = inProgressRides
            ? this.inProgressRideService.inProgressRidesToGeoJson(
                  inProgressRides
              )
            : undefined;
        super.setSourceData(mapboxMap, geoJson);
    }
}
